<template>
    <div class="l-item">
        <div class='l-a' :title="a_info">
           <div class="name"> {{item.a_object.name}}<span class="help-class" v-if="index===0" title="点击出现提示" @click="$emit('help-msg',1)">?</span></div>
           <input type="text" 
            v-model.number.lazy="item.a_object.value" 
            onfocus="this.select()" 
            @change="$emit('update_data')"
            onkeyup="this.value=this.value.replace(/[^\d.]/g,'')"
            >
        </div>
        <div class='l-b' :title="b_info">
           <div class="name"> {{item.b_object.name}}</div>
           <input type="text" 
           v-model.lazy="item.b_object.value" 
           onfocus="this.select()" 
           @change="$emit('update_data')"
           onkeyup="this.value=this.value.replace(/[^\d.]/g,'')"
           > 
        </div>
    </div>
    
</template>

<script>

export default {
   name:'BayLItem',
   props:{
       item:Object,
       name:String,
       is_bi:Boolean,
       event_info:Object,
       index:Number,
   },
   methods:{
       update_data(){
           this.$emit('update_data');
       },
   },
   computed:{
       bi_event(){//标记事件是否为正反事件，title不一样
           return this.is_bi
       },
       a_info(){
           if(this.bi_event){
               return `${this.name} 的比率 `
           }else{
               return `所有${this.event_info.event_A} 中${this.name} 的比值 `
           }
           
       },
       b_info(){
            if(this.bi_event){
               return `${this.name}  中 ${this.event_info.event_B}  的比值 `
           }else{
               return `${this.name}  ${this.event_info.event_A} 中 ${this.event_info.event_B} 的比值 `
           }
           
       },
   }
}
</script>

<style lang="stylus" scoped>
@import '~css/item.styl';
@import '~css/var.styl';
// @import arrow_d from '~pic/arrow_down_large.png';

$input_width=60%;
.l-item
   item()
   background-color:$bay_item_l_color
   border-right:1px solid  rgba(0,0,0,0.1);

.l-a
    child_item(1)
    background-color:$bay_item_l_a_color
    color:red;
 
 
.l-b
    child_item(2)
    background-color:$bay_item_l_b_color
.help-class
    margin-left:5px;
    border:1px solid white;
    background-color:purple;
    color:white;
    width:15px;
    height:15px;
    display:inline-block;
    text-align: center;
    font-size:12px;
    border-radius:50%;
    cursor:pointer;
    &:hover
        background-color:white;
        color:purple;

</style>
